import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row custom-card-width" }
const _hoisted_2 = {
  class: "card custom-card",
  style: {"width":"300px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", {
  class: "card-title text-center",
  style: {"font-size":"20px"}
}, "Select Wallet", -1)
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "phantom" }, "Phantom", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "sollet" }, "Sollet", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "solletweb" }, "Sollet Extension", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "solflare" }, "Solflare", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "solflareweb" }, "Solflare Web", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-center mb-10", { 'display-none': _ctx.notVisible }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "phantom",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenWallet) = $event)),
              value: _ctx.WalletName.Phantom
            }, null, 8, _hoisted_6), [
              [_vModelRadio, _ctx.chosenWallet]
            ]),
            _hoisted_7,
            _hoisted_8
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chosenWallet) = $event)),
              id: "sollet",
              value: _ctx.WalletName.Sollet
            }, null, 8, _hoisted_9), [
              [_vModelRadio, _ctx.chosenWallet]
            ]),
            _hoisted_10,
            _hoisted_11
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chosenWallet) = $event)),
              id: "solletweb",
              value: _ctx.WalletName.SolletExtension
            }, null, 8, _hoisted_12), [
              [_vModelRadio, _ctx.chosenWallet]
            ]),
            _hoisted_13,
            _hoisted_14
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chosenWallet) = $event)),
              id: "solflare",
              value: _ctx.WalletName.Solflare
            }, null, 8, _hoisted_15), [
              [_vModelRadio, _ctx.chosenWallet]
            ]),
            _hoisted_16,
            _hoisted_17
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chosenWallet) = $event)),
              id: "solflareweb",
              value: _ctx.WalletName.SolflareWeb
            }, null, 8, _hoisted_18), [
              [_vModelRadio, _ctx.chosenWallet]
            ]),
            _hoisted_19,
            _hoisted_20
          ])
        ])
      ])
    ])
  ], 2))
}